import Paragraph from './Paragraph';
import React from 'react';
import { Stack, Box } from '@mui/material';
import Windowcardflipone from './Windowcardflipone';
import Windowcardfliptwo from './Windowcardfliptwo';
import Windowcardflipthree from './Windowcardflipthree';


const Featuredwindows = () => {
  return (
    <Stack
      component='section'
      direction="row"
      justifyContent='left'
      height='fit-content'
      alignItems='center'
      display='flex'
      overflowY={'hidden'}
      overflowX={'auto'}
      left='0px'
      position='relative'
      overflow='auto'
      id='egress-windows'
    
      
      sx={{
        py: 4,
        px: 4,
        '@media (max-width:420px)': {
          marginLeft:'-15px',
          paddingTop:'40px'
          
        }
      }}
    >
      <Windowcardflipone/>
      <Windowcardfliptwo/>
      <Windowcardflipthree/>
      
    </Stack>
  );
};

export default Featuredwindows;



/*
import React from 'react';
import { Stack, Box } from '@mui/material';

import Paragraph from './Paragraph';

const Featured = () => {
  return (
    <Stack
      component='section'
      direction="row"
      justifyContent='center'
      alignItems='center'
      display='flex'
      sx={{
        py: 10,
        px: 2,
      }}
    >
      <Box display='flex' flexWrap='wrap' justifyContent='space-evenly'
      minWidth={'300px'}>
        
        <img
          src='https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-escape-egress-window.png'
          alt="escape egress window"
          width= '95%'
        />
        <Paragraph
          text='Escape Egress Window'
          fontFamily={"'League Spartan', 'sans-serif'"}
          color='#ffffff'
          textAlign='center'
        />
      </Box>

      <Box display='flex' flexWrap='wrap' justifyContent='space-evenly'
      minWidth={'300px'}>
        <img
          src='https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-egress-window-system-package.png'
          itemProp="url"
          alt="Basement Egress Window Kit Product Image"
          width= '95%'
        />
        <Paragraph
          text='Egress Window Package'
          fontFamily={"'League Spartan', 'sans-serif'"}
          color='#ffffff'
          textAlign='center'
        />
      </Box>

      <Box display='flex' flexWrap='wrap' justifyContent='space-evenly'
      minWidth={'300px'}>
        <img
          src='https://img1.wsimg.com/isteam/ip/39edb80a-a042-4840-a3ba-8c86d177831b/featured-basement-egress-window-system-51ee4fe.png'
          itemProp="url"
          alt="Basement Egress Window Kit Product Image"
          width= '95%'
        />
        <Paragraph
          text='Egress Window Package'
          fontFamily={"'League Spartan', 'sans-serif'"}
          color='#ffffff'
          textAlign='center'
        />
      </Box>
    </Stack>
  );
};

export default Featured;

*/
